"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The scatter of durations against when the work happened.
 *
 * The guides are not decoration: without them a scatter is a cloud, and the
 * eye can see that a reading is high but not when it happened or by how much —
 * both of which are the point of plotting it. The plot is padded on the left
 * for the duration labels and on the right for the last time label, which is
 * centered on the plot's edge and hangs half past it.
 */
const styles = exports.styles = {
  scatter: {
    display: "x78zum5",
    paddingLeft: "x1gcoyzd",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xxcd0se",
    paddingTop: "x12t3zde",
    position: "x1n2onr6",
    $$css: true
  },
  scatterPlot: {
    position: "x1n2onr6",
    height: "xc6p2dh",
    width: "xh8yej3",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    borderLeftWidth: "xe0pwq",
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderLeftStyle: "x19ypqd9",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderLeftColor: "xemesb5",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    $$css: true
  },
  scatterPoint: {
    position: "x10l6tqk",
    width: "x1v4s8kt",
    height: "xols6we",
    marginLeft: "x1xr3403",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginBottom: "x1huwwth",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x1c1r1s3",
    opacity: "xwq05k6",
    cursor: "xsid9ct",
    $$css: true
  },
  scatterPointActive: {
    opacity: "x1hc1fzr",
    width: "x1fsd2vl",
    height: "x170jfvy",
    marginLeft: "x1mazlvb",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginBottom: "xz62fqu",
    $$css: true
  },
  gridLineVertical: {
    position: "x10l6tqk",
    top: "x13vifvy",
    bottom: "x1ey2m1c",
    width: "x1i1rx1s",
    backgroundColor: "xnhdyh",
    $$css: true
  },
  gridLineHorizontal: {
    position: "x10l6tqk",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    height: "xjm9jq1",
    backgroundColor: "xnhdyh",
    $$css: true
  },
  gridLabelVertical: {
    position: "x10l6tqk",
    top: "xdsb8wn",
    zIndex: "x1vjfegm",
    transform: "xuuh30",
    paddingTop: "x1iul6r4",
    fontFamily: "xm3uy08",
    fontSize: "x12lo8hy",
    color: "xcdm7ny",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  gridLabelHorizontal: {
    position: "x10l6tqk",
    right: "xjvjlmm",
    insetInlineStart: null,
    insetInlineEnd: null,
    transform: "x1cb1t30",
    paddingRight: "x1ijmo5n",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    fontFamily: "xm3uy08",
    fontSize: "x12lo8hy",
    color: "xcdm7ny",
    whiteSpace: "xuxw1ft",
    $$css: true
  },
  footnote: {
    color: "xcdm7ny",
    fontSize: "x9bimuu",
    fontFamily: "xm3uy08",
    paddingTop: "xefbat3",
    $$css: true
  }
};